import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";
import { MainComponent } from "./main.component";
import { AuthGuardMain } from "../auth/auth-guard.service";

const routes: Routes = [
  {
    path: "main",
    component: MainComponent,
    canActivate: [AuthGuardMain],
    children: [
      { path: "", redirectTo: "/main/account", pathMatch: "full" },
      {
        path: "account",
        loadChildren: () =>
          import("./account/account.module").then((m) => m.AccountModule),
      },
      {
        path: "dashboard",
        loadChildren: () =>
          import("./dashboard/dashboard.module").then((m) => m.DashboardModule),
      },
      {
        path: "stop",
        loadChildren: () =>
          import("./manage-stop/manage-stop.module").then(
            (m) => m.BusStopModule
          ),
      },
      {
        path: "bus",
        loadChildren: () =>
          import("./bus-management/bus.module").then((m) => m.BusModule),
      },
      {
        path: "password",
        loadChildren: () =>
          import("./password/password.module").then((m) => m.PasswordModule),
      },
      {
        path: "manage-stop",
        loadChildren: () =>
          import("../main/manage-stop/manage-stop.module").then(
            (m) => m.BusStopModule
          ),
      },
      {
        path: "vehicle",
        loadChildren: () =>
          import("../main/vehicle/vehicle.module").then((m) => m.VehicleModule),
      },
      {
        path: "trip",
        loadChildren: () =>
          import("../main/trip/trips.module").then((m) => m.TripsModule),
      },
      {
        path: "terminal",
        loadChildren: () =>
          import("../main/terminal/terminal.module").then(
            (m) => m.TerminalModule
          ),
      },
      {
        path: "apikey",
        loadChildren: () =>
          import("../main/api-key/api-key.module").then((m) => m.ApiKeyModule),
      },
      {
        path: "driver",
        loadChildren: () =>
          import("../main/driver/driver.module").then((m) => m.DriverModule),
      },
      {
        path: "conductor",
        loadChildren: () =>
          import("../main/conductor/conductor.module").then(
            (m) => m.ConductorModule
          ),
      },
      {
        path: "payment-management",
        loadChildren: () =>
          import("../main/payment-management/payment-management.module").then(
            (m) => m.PaymentManagementModule
          ),
      },
      {
        path: "booking",
        loadChildren: () =>
          import("../main/booking-management/booking.module").then(
            (m) => m.BookingModule
          ),
      },
      {
        path: "map",
        loadChildren: () =>
          import("../main/map/map.module").then((m) => m.MapModule),
      },
      {
        path: "setting",
        loadChildren: () =>
          import("../main/setting-management/setting-management.module").then(
            (m) => m.SettingManagementModule
          ),
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class MainRoutingModule {}
